import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ConnectionsProvider } from './state/connections';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConnectionsProvider>
      <App />
    </ConnectionsProvider>
  </StrictMode>,
);
